import { Add } from '@mui/icons-material';
import ButtonComponent from 'components/ButtonComponent';
import DropdownComponent from 'components/DropdownComponent';
import ModalComponent from 'components/ModalComponent';
import TableComponent, { IColumnProps } from 'components/TableComponent';
import { useContext, useEffect, useState } from 'react';
import {
  useDeleteVirtualAlarmCentralDeviceById,
  useGetAlllDevicesByPartitionId,
} from 'services/AlarmCentralService/Virtual/hooks/useMutation';
import {
  IDeviceVirtualAlarmCentralProps,
  IPartitionProps,
} from 'services/AlarmCentralService/Virtual/types';
import VirtualAlarmCentralDeviceEditionModal from './VirtualAlarmCentralDeviceEditionModal';
import ButtonActionsComponent from 'components/ButtonActionsComponent';
import ConfirmDeleteModalComponent from 'components/ConfirmDeleteModalComponent';
import { AppContext } from 'context/AppContextProvider';

interface VirtualCentralDeviceManagementModalProps {
  isOpen: boolean;
  onClose: () => void;
  partitions: IPartitionProps[];
  partitionIdSelectedToEdit?: number;
}

const VirtualCentralDeviceManagementModal = ({
  isOpen,
  onClose,
  partitions,
  partitionIdSelectedToEdit,
}: VirtualCentralDeviceManagementModalProps) => {
  const [partitionsOptions, setPartitionsOptions] = useState<
    { label: string; value: number }[]
  >([]);
  const { showSnackbar } = useContext(AppContext);
  const [selectedItemToDelete, setSelectedItemToDelete] =
    useState<IDeviceVirtualAlarmCentralProps>();
  const [isVisibleDeleteItemModal, setIsVisibleDeleteItemModal] =
    useState<boolean>(false);
  const [isVisibleEditionModal, setIsVisibleEditionModal] =
    useState<boolean>(false);
  const [
    isOpenVirtualAlarmCentralDeviceEditionModal,
    setIsOpenVirtualAlarmCentralDeviceEditionModal,
  ] = useState(false);
  const [partitionSelected, setPartitionSelected] = useState<number>();
  const {
    mutateAsync: mutateDeleteVirtualAlarmCentralDeviceById,
    isLoading: isLoadingDeleteVirtualAlarmCentralDeviceById,
  } = useDeleteVirtualAlarmCentralDeviceById();
  const [devices, setDevices] = useState<IDeviceVirtualAlarmCentralProps[]>([]);
  const columns: IColumnProps[] = [
    { label: 'Nome', id: 'name' },
    {
      id: 'id',
      label: 'Ações',
      align: 'center',
      width: 0,
      render: (id) => (
        <ButtonActionsComponent
          isWithDefaultOptionsList
          handleDelete={() => handleDeleteItem(Number(id))}
          handleEdit={() => handleEdit(Number(id))}
        />
      ),
    },
  ];

  const handleDeleteItem = (id: number) => {
    if (devices) setSelectedItemToDelete(devices.find((d) => d.id === id));
    setIsVisibleDeleteItemModal(true);
  };

  const handleEdit = (id: number) => {
    // mutateIvsDeviceAsync(id).then(setDeviceToEdit);
    setIsVisibleEditionModal(true);
  };

  const {
    mutateAsync: mutateGetAlllDevicesByPartitionId,
    isLoading: isLoadingGetAlllDevicesByPartitionId,
  } = useGetAlllDevicesByPartitionId();

  const onCloseVirtualAlarmCentralDeviceEditionModal = () => {
    setIsOpenVirtualAlarmCentralDeviceEditionModal(false);
    requestDevices();
  };

  const handleCloseAndClearDelete = () => {
    setIsVisibleDeleteItemModal(false);
    setSelectedItemToDelete(undefined);
    requestDevices();
  };

  const handleConfirmDeletion = () => {
    if (selectedItemToDelete?.id)
      mutateDeleteVirtualAlarmCentralDeviceById(selectedItemToDelete?.id).then(
        () => {
          handleCloseAndClearDelete();
          showSnackbar('Dispositivo desvinculado com sucesso.', 'success');
        },
      );
  };

  const requestDevices = () => {
    if (partitionSelected) {
      mutateGetAlllDevicesByPartitionId(partitionSelected).then(setDevices);
    }
  };

  useEffect(() => {
    requestDevices();
  }, [partitionSelected]);

  useEffect(() => {
    if (partitionIdSelectedToEdit) {
      const partition = partitions.find(
        (p) => p.id === partitionIdSelectedToEdit,
      );
      if (partition) setPartitionSelected(partition.id);
    }
  }, [partitionIdSelectedToEdit]);

  useEffect(() => {
    if (partitions) {
      const values: { label: string; value: number }[] = [];
      partitions.forEach((v) => {
        if (v.code != 0) {
          values.push({ label: v.name, value: v.id });
        }
      });
      setPartitionsOptions(values);
    }
  }, [partitions]);
  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title="Vínculo de dispositivo com partição"
    >
      <DropdownComponent
        label="Partição"
        onChange={setPartitionSelected}
        optionLabel="label"
        optionValue="value"
        options={partitionsOptions}
        value={partitionSelected}
      />
      {partitionSelected && (
        <TableComponent
          height={'10'}
          isLoading={isLoadingGetAlllDevicesByPartitionId}
          columns={columns}
          rows={devices}
          emptyMessage="Nenhum dispositivo vinculado."
          title={'Dispositivos'}
          additionalTitleComponent={
            <ButtonComponent
              startIcon={<Add />}
              onClick={() => {
                setIsOpenVirtualAlarmCentralDeviceEditionModal(true);
              }}
            >
              Adicionar
            </ButtonComponent>
          }
        />
      )}
      <VirtualAlarmCentralDeviceEditionModal
        isOpen={isOpenVirtualAlarmCentralDeviceEditionModal}
        onClose={() => onCloseVirtualAlarmCentralDeviceEditionModal()}
        partitionId={partitionSelected ?? 0}
        zone={devices.length + 1}
      />
      <ConfirmDeleteModalComponent
        isLoading={isLoadingDeleteVirtualAlarmCentralDeviceById}
        isVisibleDeleteDialog={isVisibleDeleteItemModal}
        setIsVisibleDeleteDialog={setIsVisibleDeleteItemModal}
        title={'Excluir Dispositivo'}
        message={`Tem certeza que deseja desvincular o dispositivo "${selectedItemToDelete?.name}"?`}
        handleCancelDeletion={handleCloseAndClearDelete}
        handleConfirmDeletion={handleConfirmDeletion}
      />
    </ModalComponent>
  );
};

export default VirtualCentralDeviceManagementModal;
